import { render } from "./DateInput.vue?vue&type=template&id=70a38c42&scoped=true&ts=true"
import script from "./DateInput.vue?vue&type=script&lang=ts"
export * from "./DateInput.vue?vue&type=script&lang=ts"

import "./date-input.scss?vue&type=style&index=0&id=70a38c42&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a38c42"]])

export default __exports__